export enum ConditionType {

    BOOLEAN_EQUALS          = 'boolean-equals',

    NOT_NULL                = 'not-null',
    IS_NULL                 = 'is-null',

    INCLUDES                = 'includes',
    EXCLUDES                = 'excludes',

    ARRAY_INTERSECTION      = 'array-intersection',
    ARRAY_NON_INTERSECTION  = 'array-non-intersection',

    NUMBER_GREATER_THAN     = 'number-greater-than',
    NUMBER_LESS_THAN        = 'number-less-than',
    NUMBER_EQUALS           = 'number-equals',
    NUMBER_BETWEEN          = 'number-between',

    STRING_EQUALS           = 'string-equals',
    STRING_CONTAINS         = 'string-contains',

    DATE_FIXED_BEFORE       = 'date-fixed-before',
    DATE_FIXED_AFTER        = 'date-fixed-after',
    DATE_FIXED_EQUALS       = 'date-fixed-equals',
    DATE_FIXED_RANGE        = 'date-fixed-range',

    DATE_RELATIVE_RANGE     = 'date-relative-range',
    DATE_RELATIVE_AFTER     = 'date-relative-after',
    DATE_RELATIVE_BEFORE    = 'date-relative-before',
    DATE_RELATIVE_EQUALS    = 'date-relative-equals',
    DATE_RELATIVE_PERIOD    = 'date-relative-period',

    DATERANGE_FIXED_INCLUDES    = 'daterange-fixed-includes',   // Task fully covers the filter range. filter range within task start-end
    DATERANGE_FIXED_OVERLAPS    = 'daterange-fixed-overlaps',   // Do these two ranges touch or share any common time? Task intersects the range in any way (partial or full).
    DATERANGE_FIXED_WITHIN      = 'daterange-fixed-within',     // Task is fully inside the filter range.

    DATERANGE_RELATIVE_INCLUDES    = 'daterange-relative-includes',
    DATERANGE_RELATIVE_OVERLAPS    = 'daterange-relative-overlaps',
    DATERANGE_RELATIVE_WITHIN      = 'daterange-relative-within',

    // Composite: field changed over time (from -> to within a date range).
    // The concrete date operator + date value live inside the condition value.
    TASK_STATUS_CHANGED                 = 'task-status-changed',

}

export function IConditionTypeFactory(conditionType:ConditionType):typeof IConditionType {

    switch (conditionType) {

        case ConditionType.NOT_NULL             : return ConditionType_NotNull
        case ConditionType.IS_NULL              : return ConditionType_IsNull

        case ConditionType.INCLUDES             : return ConditionType_Includes
        case ConditionType.EXCLUDES             : return ConditionType_Excludes
        case ConditionType.ARRAY_INTERSECTION       : return ConditionType_ArrayIntersection
        case ConditionType.ARRAY_NON_INTERSECTION   : return ConditionType_ArrayNonIntersection

        case ConditionType.NUMBER_EQUALS        : return ConditionType_NumberEquals
        case ConditionType.NUMBER_GREATER_THAN  : return ConditionType_NumberGreaterThan
        case ConditionType.NUMBER_LESS_THAN     : return ConditionType_NumberLessThan
        case ConditionType.NUMBER_BETWEEN       : return ConditionType_NumberBetween

        case ConditionType.STRING_EQUALS        : return ConditionType_StringEquals
        case ConditionType.STRING_CONTAINS      : return ConditionType_StringContains

        case ConditionType.DATE_RELATIVE_RANGE  : return ConditionType_DateRelativeRange
        case ConditionType.DATE_RELATIVE_AFTER  : return ConditionType_DateRelativeAfter
        case ConditionType.DATE_RELATIVE_BEFORE : return ConditionType_DateRelativeBefore
        case ConditionType.DATE_RELATIVE_EQUALS : return ConditionType_DateRelativeEquals
        case ConditionType.DATE_RELATIVE_PERIOD : return ConditionType_DateRelativePeriod

        case ConditionType.DATE_FIXED_BEFORE    : return ConditionType_DateFixedBefore
        case ConditionType.DATE_FIXED_AFTER     : return ConditionType_DateFixedAfter
        case ConditionType.DATE_FIXED_EQUALS    : return ConditionType_DateFixedEquals
        case ConditionType.DATE_FIXED_RANGE     : return ConditionType_DateFixedRange

        case ConditionType.BOOLEAN_EQUALS       : return ConditionType_BooleanEquals

        case ConditionType.DATERANGE_FIXED_INCLUDES     : return ConditionType_DaterangeFixedIncludes
        case ConditionType.DATERANGE_FIXED_OVERLAPS     : return ConditionType_DaterangeFixedOverlaps
        case ConditionType.DATERANGE_FIXED_WITHIN       : return ConditionType_DaterangeFixedWithin
        case ConditionType.DATERANGE_RELATIVE_WITHIN    : return ConditionType_DaterangeRelativeWithin
        case ConditionType.DATERANGE_RELATIVE_INCLUDES  : return ConditionType_DaterangeRelativeIncludes
        case ConditionType.DATERANGE_RELATIVE_OVERLAPS  : return ConditionType_DaterangeRelativeOverlaps

        case ConditionType.TASK_STATUS_CHANGED               : return ConditionType_StatusChanged

        default:
            console.error("UNKNWON CONDITON TYPE in factory #3djasdw type=", conditionType)
            return IConditionType
    }

}

export enum ConditionValueType {
    ARRAY_ID                        = 'array-id',
    NUMBER                          = 'number',
    STRING                          = 'string',
    OBJECT_DATE_RANGE_RELATIVE      = 'object-date-relative', // real dateRange relativ like 30 days ago -> in 60 days
    // OBJECT_DATE_RANGE_FIXED         = 'object-daterange-fixed', // real dateRange jun 10 - jul 30 - see DATE_RANGE
    DATE_RELATIVE                   = 'date-relative',
    DATE_RELATIVE_PERIOD            = 'date-relative-period',   // this week, last month etc ... relatevie period like date in period last week
    MOMENT_DATE                     = 'moment-date',
    DATE_RANGE                      = 'date-range', // date range !
    VOID                            = 'void',
    BOOLEAN                         = 'boolean'
}

export class IConditionType {
    static type         : ConditionType
    static label        : string
    static groupHeader? : string
    static valueType    : ConditionValueType

    public static toOption():Option {
        return {
            value   : this.type,
            label   : this.label
        }
    }
}

// NULL

export class ConditionType_IsNull extends IConditionType {
    static type         = ConditionType.IS_NULL
    static label        = 'Not set'
    static valueType    = ConditionValueType.VOID
}

export class ConditionType_NotNull extends IConditionType {
    static type         = ConditionType.NOT_NULL
    static label        = 'Set'
    static valueType    = ConditionValueType.VOID
}

// COMPOSITE (status changed from -> to within a date range)
// The composite value { fromValues, toValues, dateType, dateValue } is filled with its defaults
// in Condition.set value (keyed on the TASK_STATUS_CHANGED type), so it is normalized despite the
// VOID valueType - the form only reads it.

export class ConditionType_StatusChanged extends IConditionType {
    static type         = ConditionType.TASK_STATUS_CHANGED
    static label        = 'Changed'
    static valueType    = ConditionValueType.VOID
}


// BOOLEAN

export class ConditionType_BooleanEquals extends IConditionType {
    static type         = ConditionType.BOOLEAN_EQUALS
    static label        = 'Is'
    static valueType    = ConditionValueType.BOOLEAN
}

// ARRAYS

export class ConditionType_Includes extends IConditionType {
    static type         = ConditionType.INCLUDES
    static label        = 'Is one of'
    static valueType    = ConditionValueType.ARRAY_ID
}

export class ConditionType_Excludes extends IConditionType {
    static type         = ConditionType.EXCLUDES
    static label        = 'Is NOT one of'
    static valueType    = ConditionValueType.ARRAY_ID
}

export class ConditionType_ArrayIntersection extends IConditionType {
    static type         = ConditionType.ARRAY_INTERSECTION
    static label        = 'Is one of'
    static valueType    = ConditionValueType.ARRAY_ID
}

export class ConditionType_ArrayNonIntersection extends IConditionType {
    static type         = ConditionType.ARRAY_NON_INTERSECTION
    static label        = 'Is NOT one of'
    static valueType    = ConditionValueType.ARRAY_ID
}

// NUMBERS

export class ConditionType_NumberGreaterThan extends IConditionType {
    static type         = ConditionType.NUMBER_GREATER_THAN
    static label        = 'Greater than'
    static valueType    = ConditionValueType.NUMBER
}

export class ConditionType_NumberLessThan extends IConditionType {
    static type         = ConditionType.NUMBER_LESS_THAN
    static label        = 'Less than'
    static valueType    = ConditionValueType.NUMBER
}

export class ConditionType_NumberBetween extends IConditionType {
    static type         = ConditionType.NUMBER_BETWEEN
    static label        = 'Between'
    static valueType    = ConditionValueType.NUMBER
}

export class ConditionType_NumberEquals extends IConditionType {
    static type         = ConditionType.NUMBER_EQUALS
    static label        = 'Equals'
    static valueType    = ConditionValueType.NUMBER
}

// STRING

export class ConditionType_StringEquals extends IConditionType {
    static type         = ConditionType.STRING_EQUALS
    static label        = 'Equals'
    static valueType    = ConditionValueType.STRING
}

export class ConditionType_StringContains extends IConditionType {
    static type         = ConditionType.STRING_CONTAINS
    static label        = 'Contains'
    static valueType    = ConditionValueType.STRING
}

// DATE RELATIVE

export class ConditionType_DateRelativeBefore extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_BEFORE
    static label        = 'Before'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.DATE_RELATIVE
}

export class ConditionType_DateRelativeAfter extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_AFTER
    static label        = 'After'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.DATE_RELATIVE
}

export class ConditionType_DateRelativeRange extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_RANGE
    static label        = 'In range'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.OBJECT_DATE_RANGE_RELATIVE
}

export class ConditionType_DateRelativeEquals extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_EQUALS
    static label        = 'Is'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.DATE_RELATIVE
}

export class ConditionType_DateRelativePeriod extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_PERIOD
    static label        = 'In period'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.DATE_RELATIVE_PERIOD
}

// DATE FIXED

export class ConditionType_DateFixedBefore extends IConditionType {
    static type         = ConditionType.DATE_FIXED_BEFORE
    static label        = 'Before'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.MOMENT_DATE
}

export class ConditionType_DateFixedAfter extends IConditionType {
    static type         = ConditionType.DATE_FIXED_AFTER
    static label        = 'After'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.MOMENT_DATE
}

export class ConditionType_DateFixedEquals extends IConditionType {
    static type         = ConditionType.DATE_FIXED_EQUALS
    static label        = 'Is'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.MOMENT_DATE
}

export class ConditionType_DateFixedRange extends IConditionType {
    static type         = ConditionType.DATE_FIXED_RANGE
    static label        = 'In range'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.DATE_RANGE
}


// DATERANGE
//      FIXED

export class ConditionType_DaterangeFixedIncludes extends IConditionType {
    static type         = ConditionType.DATERANGE_FIXED_INCLUDES
    static label        = 'Includes'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.DATE_RANGE
}

export class ConditionType_DaterangeFixedOverlaps extends IConditionType {
    static type         = ConditionType.DATERANGE_FIXED_OVERLAPS
    static label        = 'Overlaps'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.DATE_RANGE
}

export class ConditionType_DaterangeFixedWithin extends IConditionType {
    static type         = ConditionType.DATERANGE_FIXED_WITHIN
    static label        = 'Within'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.DATE_RANGE
}

// DATERANGE RELATIVE

export class ConditionType_DaterangeRelativeIncludes extends IConditionType {
    static type         = ConditionType.DATERANGE_RELATIVE_INCLUDES
    static label        = 'Includes'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.OBJECT_DATE_RANGE_RELATIVE /// ???
}

export class ConditionType_DaterangeRelativeOverlaps extends IConditionType {
    static type         = ConditionType.DATERANGE_RELATIVE_OVERLAPS
    static label        = 'Overlaps'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.OBJECT_DATE_RANGE_RELATIVE /// ???
}

export class ConditionType_DaterangeRelativeWithin extends IConditionType {
    static type         = ConditionType.DATERANGE_RELATIVE_WITHIN
    static label        = 'Within'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.OBJECT_DATE_RANGE_RELATIVE /// ???
}